import { render, staticRenderFns } from "./AuditCriteriaRemovalWarning.vue?vue&type=template&id=07d935a2"
import script from "./AuditCriteriaRemovalWarning.vue?vue&type=script&lang=ts"
export * from "./AuditCriteriaRemovalWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports